import { render } from "./SupprimerGroupe.vue?vue&type=template&id=198439d2"
import script from "./SupprimerGroupe.vue?vue&type=script&lang=js"
export * from "./SupprimerGroupe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__